import Viewport from '@vaersaagod/tools/Viewport';
import Components from '@vaersaagod/tools/Components';

import 'gsap';
import './lib/polyfills';
import lazySizes from './lib/lazysizes';
import ShareLinks from './components/ShareLinks';

require('gsap/TweenLite');
require('gsap/CSSPlugin');
require('gsap/EasePack');
require('gsap/ScrollToPlugin');

/*
*   Bootstrap app
*
 */
const init = () => {
    Viewport.init();
    Viewport.initTabbing();
    Viewport.releaseTabbing();
    Components.init();
    lazySizes.init();
    ShareLinks.init();
};

require('doc-ready')(init);



// WEBPACK FOOTER //
// ./src/js/main.js